import { createTV } from "tailwind-variants"

import { classGroups as searchView } from "~/lib/searchView"
import { classGroups as navigation } from "~/lib/navigation"
import { classGroups as list } from "~/lib/list"
// import colors from "~/../colors"
import fonts from "@anitrove/design/fonts"

export const tv = createTV({
	twMergeConfig: {
		theme: {
			// colors: Object.keys(colors.dark),
		},
		classGroups: {
			"font-size": [{ text: Object.keys(fonts) }],
			...searchView,

			...navigation,
			...list,
		},
	},
})
